export function notLoggedInModal(): void {
  $('.js-not-logged-in-modal').click(function(e){
    e.preventDefault();
    $('.c-secondary-modal_wrapper, .c-secondary-modal_not-logged-in').fadeIn();
  });

  $('.js-secondary-modal-close').click(function(){
    $('.c-secondary-modal_wrapper, .c-secondary-modal_content').fadeOut();
  });
}
